/**
 * College Degrees List - Comprehensive degree data for React applications
 *
 * Expanded to include 300+ real academic degrees, professional degrees, and certificates.
 *
 * @version 1.1.0
 * @author Sanjay Mali
 * @license MIT
 */

const degreesByLevel = {
  associate: [
    "Associate of Applied Science (AAS)",
    "Associate of Arts (AA)",
    "Associate of Business Administration (ABA)",
    "Associate of Engineering (AE)",
    "Associate of Fine Arts (AFA)",
    "Associate of General Studies (AGS)",
    "Associate of Science (AS)",
    "Associate of Occupational Studies (AOS)",
    "Associate of Veterinary Technology (AVT)",
    "Associate of Information Technology (AIT)",
    "Associate of Science in Nursing (ASN)",
    "Associate of Applied Business (AAB)",
    "Associate in Management (AIM)",
    "Associate of Applied Arts (AAA)",
    "Associate of Culinary Arts (ACA)",
    "Associate of Applied Technology (AAT)",
    "Associate of Early Childhood Education (AECE)",
    "Associate in Paralegal Studies (APParalegal)",
    "Associate of Criminal Justice (ACJ)",
    "Associate of Hospitality Management (AHM)",
    "Associate of Occupational Therapy Assistant (AOTA)",
    "Associate of Veterinary Nursing (AVN)",
    "Associate of Medical Laboratory Technology (AMLT)",
    "Associate of Radiologic Technology (ART)",
    "Associate of Dental Hygiene (ADH)",
  ],
  bachelor: [
    "Bachelor of Applied Science (BAS)",
    "Bachelor of Architecture (BArch)",
    "Bachelor of Arts (BA)",
    "Bachelor of Business Administration (BBA)",
    "Bachelor of Commerce (BCom)",
    "Bachelor of Computer Applications (BCA)",
    "Bachelor of Computer Science (BCS)",
    "Bachelor of Science (BSc)",
    "Bachelor of Engineering (BE)",
    "Bachelor of Technology (BTech)",
    "Bachelor of Fine Arts (BFA)",
    "Bachelor of Laws (LLB)",
    "Bachelor of Education (BEd)",
    "Bachelor of Medicine, Bachelor of Surgery (MBBS)",
    "Bachelor of Dental Surgery (BDS)",
    "Bachelor of Pharmacy (BPharm)",
    "Bachelor of Nursing (BN)",
    "Bachelor of Architecture (B.Arch)",
    "Bachelor of Design (BDes)",
    "Bachelor of Commerce (Honours) (BCom Hons)",
    "Bachelor of Journalism and Mass Communication (BJMC)",
    "Bachelor of Physiotherapy (BPT)",
    "Bachelor of Occupational Therapy (BOT)",
    "Bachelor of Veterinary Science (BVSc)",
    "Bachelor of Social Work (BSW)",
    "Bachelor of Music (BMus)",
    "Bachelor of Hotel Management (BHM)",
    "Bachelor of Environmental Science (BEnvSc)",
    "Bachelor of Public Health (BPH)",
    "Bachelor of Biotechnology (BTech Biotechnology)",
    "Bachelor of Information Technology (BIT)",
    "Bachelor of Computer Engineering (BCE)",
    "Bachelor of Civil Engineering (BCEng)",
    "Bachelor of Mechanical Engineering (BME)",
    "Bachelor of Electrical Engineering (BEE)",
    "Bachelor of Chemical Engineering (BChE)",
    "Bachelor of Aerospace Engineering (BAeE)",
    "Bachelor of Marine Engineering (BMarE)",
    "Bachelor of Agricultural Science (BASc)",
    "Bachelor of Forestry (BFor)",
    "Bachelor of Commerce in Accounting (BCom Accounting)",
    "Bachelor of Commerce in Finance (BCom Finance)",
    "Bachelor of Business in Hospitality (BBH)",
    "Bachelor of Applied Arts (BAA)",
    "Bachelor of Occupational Health and Safety (BOHS)",
    "Bachelor of Animation (BAnim)",
    "Bachelor of Fine Arts in Visual Arts (BFA Visual Arts)",
    "Bachelor of Landscape Architecture (BLA)",
    "Bachelor of Urban Planning (BUP)",
    "Bachelor of Actuarial Science (BActSc)",
    "Bachelor of Statistics (BStat)",
    "Bachelor of Data Science (BDSci)",
    "Bachelor of Commerce in E-Commerce (BCom E-Com)",
    "Bachelor of Sports Science (BSpSc)",
    "Bachelor of Radiography (BRad)",
    "Bachelor of Speech and Language Pathology (B.SLP)",
    "Bachelor of Dental Technology (BDT)",
    "Bachelor of Fashion Design (BFD)",
    "Bachelor of Interior Design (BID)",
    "Bachelor of Theology (BTh)",
    "Bachelor of Fine Arts in Theatre (BFA Theatre)",
    "Bachelor of Film and Television (BFTV)",
    "Bachelor of Science in Mathematics (BSc Mathematics)",
    "Bachelor of Science in Physics (BSc Physics)",
    "Bachelor of Science in Chemistry (BSc Chemistry)",
    "Bachelor of Science in Biology (BSc Biology)",
    "Bachelor of Science in Statistics (BSc Statistics)",
    "Bachelor of Science in Geology (BSc Geology)",
    "Bachelor of Science in Forestry (BSc Forestry)",
    "Bachelor of Science in Environmental Technology (BSc EnvTech)",
    "Bachelor of Science in Nutrition and Dietetics (BSc Nutrition)",
    "Bachelor of Fine Arts in Graphic Design (BFA Graphic Design)",
    "Bachelor of Veterinary Technology (BVT)",
    "Bachelor of Commerce in Business Analytics (BCom BA)",
    "Bachelor of Commerce in International Business (BCom IB)",
    "Bachelor of Science in Cybersecurity (BSc Cybersecurity)",
    "Bachelor of Science in Artificial Intelligence (BSc AI)",
  ],
  master: [
    "Master of Arts (MA)",
    "Master of Science (MSc)",
    "Master of Business Administration (MBA)",
    "Master of Engineering (MEng)",
    "Master of Technology (MTech)",
    "Master of Computer Applications (MCA)",
    "Master of Education (MEd)",
    "Master of Laws (LLM)",
    "Master of Philosophy (MPhil)",
    "Master of Fine Arts (MFA)",
    "Master of Public Health (MPH)",
    "Master of Social Work (MSW)",
    "Master of Commerce (MCom)",
    "Master of Public Administration (MPA)",
    "Master of Science in Nursing (MSN)",
    "Master of Environmental Management (MEM)",
    "Master of Architecture (MArch)",
    "Master of Design (MDes)",
    "Master of Urban Planning (MUP)",
    "Master of Information Technology (MIT)",
    "Master of Data Science (MDS)",
    "Master of Computer Science (MCS)",
    "Master of Business Analytics (MSBA)",
    "Master of Finance (MFin)",
    "Master of International Business (MIB)",
    "Master of Biotechnology (MTech Biotechnology)",
    "Master of Engineering in Civil Engineering (MEng Civil)",
    "Master of Engineering in Mechanical Engineering (MEng Mechanical)",
    "Master of Engineering in Electrical Engineering (MEng Electrical)",
    "Master of Science in Applied Mathematics (MSc Applied Math)",
    "Master of Science in Physics (MSc Physics)",
    "Master of Science in Chemistry (MSc Chemistry)",
    "Master of Laws in Corporate Law (LLM Corporate)",
    "Master of Arts in Economics (MA Economics)",
    "Master of Arts in Political Science (MA Political Science)",
    "Master of Arts in English (MA English)",
    "Master of Philosophy in Education (MPhil Education)",
    "Master of Public Policy (MPP)",
    "Master of Development Studies (MDS)",
    "Master of International Relations (MIR)",
    "Master of Human Resource Management (MHRM)",
    "Master of Marketing (MMkt)",
    "Master of Library and Information Science (MLIS)",
    "Master of Occupational Therapy (MOT)",
    "Master of Physiotherapy (MPT)",
    "Master of Sports Management (MSM)",
    "Master of Health Administration (MHA)",
    "Master of Clinical Psychology (MClinPsych)",
    "Master of Fine Arts in Creative Writing (MFA Creative Writing)",
    "Master of Science in Artificial Intelligence (MSc AI)",
    "Master of Science in Cybersecurity (MSc Cybersecurity)",
    "Master of Science in Data Analytics (MSc Data Analytics)",
    "Master of Science in Bioinformatics (MSc Bioinformatics)",
    "Master of Science in Robotics (MSc Robotics)",
    "Master of Geographical Information Systems (MGIS)",
    "Master of Forensic Science (MForenSc)",
    "Master of Counseling (MCouns)",
    "Master of Theology (MTh)",
    "Master of Applied Statistics (MAppStat)",
    "Master of Entrepreneurship (MEntrep)",
  ],
  doctoral: [
    "Doctor of Philosophy (PhD)",
    "Doctor of Medicine (MD)",
    "Doctor of Dental Surgery (DDS)",
    "Doctor of Dental Medicine (DMD)",
    "Doctor of Veterinary Medicine (DVM)",
    "Doctor of Pharmacy (PharmD)",
    "Doctor of Education (EdD)",
    "Doctor of Nursing Practice (DNP)",
    "Doctor of Psychology (PsyD)",
    "Doctor of Social Work (DSW)",
    "Doctor of Public Health (DrPH)",
    "Doctor of Musical Arts (DMA)",
    "Doctor of Engineering (DEng)",
    "Doctor of Business Administration (DBA)",
    "Doctor of Physical Therapy (DPT)",
    "Doctor of Clinical Psychology (DClinPsy)",
    "Doctor of Health Science (DHSc)",
    "Doctor of Laws (LLD)",
    "Doctor of Ministry (DMin)",
    "Doctor of Pharmacy Practice (DPharmPractice)",
    "Doctor of Science (DSc)",
    "Doctor of Letters (DLitt)",
    "Doctor of Arts (DA)",
    "Doctor of Philosophy in Engineering (PhD Eng)",
    "Doctor of Philosophy in Computer Science (PhD CS)",
    "Doctor of Philosophy in Biology (PhD Biology)",
    "Doctor of Philosophy in Chemistry (PhD Chemistry)",
    "Doctor of Philosophy in Physics (PhD Physics)",
    "Doctor of Philosophy in Economics (PhD Economics)",
    "Doctor of Philosophy in Education (PhD Education)",
    "Doctor of Philosophy in History (PhD History)",
    "Doctor of Philosophy in Mathematics (PhD Mathematics)",
    "Doctor of Philosophy in Public Policy (PhD Public Policy)",
    "Doctor of Philosophy in Clinical Psychology (PhD Clin Psych)",
    "Doctor of Philosophy in Neuroscience (PhD Neuroscience)",
    "Doctor of Philosophy in Environmental Science (PhD EnvSci)",
  ],
  certificate: [
    "Graduate Certificate",
    "Postgraduate Certificate",
    "Professional Certificate",
    "Microcredential Certificate",
    "Diploma Program",
    "Postgraduate Diploma (PGDip)",
    "Diploma in Management (DipMgt)",
    "Diploma in Nursing",
    "Diploma in Pharmacy",
    "Diploma in Education (DipEd)",
    "Certificate in Project Management (PMP Prep)",
    "Certificate in Cybersecurity",
    "Certificate in Data Analytics",
    "Certificate in Cloud Computing",
    "Certificate in Artificial Intelligence",
    "Certificate in Digital Marketing",
    "Certificate in UX/UI Design",
    "Certificate in Web Development",
    "Certificate in TESL / TEFL",
    "Certificate in Supply Chain Management",
    "Certificate in Human Resource Management",
    "Certificate in Clinical Research",
    "Certificate in Forensic Accounting",
    "Certificate in Occupational Health and Safety",
    "Certificate in Financial Planning",
    "Certificate in Hospitality Management",
    "Certificate in Food Safety",
    "Certificate in Event Management",
    "Certificate in Early Childhood Education",
    "Apprenticeship Certificate",
    "Vocational Training Certificate",
    "Industry Certification (Vendor-specific)",
    "Online Course Certificate",
    "Certificate in Blockchain Technology",
    "Certificate in Renewable Energy",
    "Certificate in Biostatistics",
    "Certificate in Language Proficiency (e.g., TOEFL/IELTS Prep)",
  ],
};

const extraBachelorSpecializations = [
  "Bachelor of Science in Computer Science (BSc Computer Science)",
  "Bachelor of Science in Information Technology (BSc IT)",
  "Bachelor of Science in Software Engineering (BSc Software Engineering)",
  "Bachelor of Science in Data Science (BSc Data Science)",
  "Bachelor of Science in Artificial Intelligence (BSc AI)",
  "Bachelor of Science in Cyber Security (BSc Cyber Security)",
  "Bachelor of Science in Electrical and Electronics Engineering (BSc EEE)",
  "Bachelor of Science in Electronics and Communication Engineering (BSc ECE)",
  "Bachelor of Science in Mechanical Engineering (BSc Mechanical)",
  "Bachelor of Science in Civil Engineering (BSc Civil)",
  "Bachelor of Science in Chemical Engineering (BSc Chemical)",
  "Bachelor of Science in Petroleum Engineering (BSc Petroleum)",
  "Bachelor of Science in Biomedical Engineering (BSc Biomedical)",
  "Bachelor of Science in Environmental Engineering (BSc Environmental)",
  "Bachelor of Science in Materials Science (BSc Materials)",
  "Bachelor of Science in Biotechnology (BSc Biotechnology)",
  "Bachelor of Science in Microbiology (BSc Microbiology)",
  "Bachelor of Science in Biochemistry (BSc Biochemistry)",
  "Bachelor of Science in Genetics (BSc Genetics)",
  "Bachelor of Science in Pharmacology (BSc Pharmacology)",
  "Bachelor of Science in Nursing (BSc Nursing)",
  "Bachelor of Science in Optometry (BSc Optometry)",
  "Bachelor of Science in Radiology (BSc Radiology)",
  "Bachelor of Science in Speech Therapy (BSc Speech Therapy)",
  "Bachelor of Science in Occupational Therapy (BSc Occupational Therapy)",
  "Bachelor of Economics (BEcon)",
  "Bachelor of Management Studies (BMS)",
  "Bachelor of Business Economics (BBE)",
  "Bachelor of Accountancy (BAcc)",
  "Bachelor of Financial Markets (BFM)",
  "Bachelor of International Relations (BIR)",
  "Bachelor of Languages (BA Languages)",
  "Bachelor of Philosophy (BPhil)",
  "Bachelor of Fine Arts in Photography (BFA Photography)",
  "Bachelor of Fine Arts in Animation (BFA Animation)",
  "Bachelor of Science in Hospitality and Tourism Management (BSc HTM)",
  "Bachelor of Science in Culinary Arts (BSc Culinary Arts)",
  "Bachelor of Science in Horticulture (BSc Horticulture)",
  "Bachelor of Science in Agricultural Engineering (BSc Agri Eng)",
  "Bachelor of Education (Special Education) (BEd Special Ed)",
  "Bachelor of Science in Forestry (BSc Forestry)",
  "Bachelor of Science in Fisheries Science (BSc Fisheries)",
  "Bachelor of Science in Geology (BSc Geology)",
  "Bachelor of Science in Remote Sensing and GIS (BSc RS & GIS)",
  "Bachelor of Science in Atmospheric Science (BSc Atmospheric)",
  "Bachelor of Commerce in Taxation (BCom Tax)",
  "Bachelor of Commerce in Banking and Insurance (BCom B&I)",
  "Bachelor of Commerce in Marketing (BCom Marketing)",
  "Bachelor of Science in Actuarial Studies (BSc Actuarial)",
  "Bachelor of Fine Arts in Sculpture (BFA Sculpture)",
];

const extraMasterSpecializations = [
  "Master of Science in Computer Science (MSc Computer Science)",
  "Master of Science in Information Technology (MSc IT)",
  "Master of Science in Software Engineering (MSc Software Engineering)",
  "Master of Science in Data Science (MSc Data Science)",
  "Master of Science in Artificial Intelligence (MSc AI)",
  "Master of Science in Cyber Security (MSc Cyber Security)",
  "Master of Engineering in Software (MEng Software)",
  "Master of Engineering in Aerospace (MEng Aerospace)",
  "Master of Engineering in Chemical Engineering (MEng Chemical)",
  "Master of Science in Biotechnology (MSc Biotechnology)",
  "Master of Science in Molecular Biology (MSc Molecular Biology)",
  "Master of Science in Immunology (MSc Immunology)",
  "Master of Science in Epidemiology (MSc Epidemiology)",
  "Master of Science in Clinical Research (MSc Clinical Research)",
  "Master of Science in Pharmacology (MSc Pharmacology)",
  "Master of Science in Nursing (MSc Nursing)",
  "Master of Science in Occupational Therapy (MSc OT)",
  "Master of Business Administration in Finance (MBA Finance)",
  "Master of Business Administration in Marketing (MBA Marketing)",
  "Master of Business Administration in Operations (MBA Operations)",
  "Master of Business Administration in Human Resources (MBA HR)",
  "Master of Business Administration in Information Systems (MBA IS)",
  "Master of Fine Arts in Painting (MFA Painting)",
  "Master of Arts in Media Studies (MA Media Studies)",
  "Master of Arts in Development Economics (MA Dev Econ)",
  "Master of Laws in International Law (LLM International Law)",
  "Master of Science in Structural Engineering (MSc Structural)",
  "Master of Urban Planning and Design (MUPD)",
  "Master of Geotechnical Engineering (MTech Geotech)",
  "Master of Renewable Energy Engineering (MEng Renewable Energy)",
];

const extraDoctoralSpecializations = [
  "PhD in Computer Science (PhD CS)",
  "PhD in Information Technology (PhD IT)",
  "PhD in Electrical Engineering (PhD EE)",
  "PhD in Mechanical Engineering (PhD ME)",
  "PhD in Civil Engineering (PhD CE)",
  "PhD in Chemical Engineering (PhD ChE)",
  "PhD in Materials Science (PhD Materials)",
  "PhD in Biotechnology (PhD Biotechnology)",
  "PhD in Biochemistry (PhD Biochemistry)",
  "PhD in Molecular Biology (PhD MolBio)",
  "PhD in Physics (PhD Physics)",
  "PhD in Chemistry (PhD Chemistry)",
  "PhD in Mathematics (PhD Mathematics)",
  "PhD in Statistics (PhD Statistics)",
  "PhD in Economics (PhD Economics)",
  "PhD in Sociology (PhD Sociology)",
  "PhD in Anthropology (PhD Anthropology)",
  "PhD in Linguistics (PhD Linguistics)",
  "PhD in Psychology (PhD Psychology)",
  "PhD in Neuroscience (PhD Neuroscience)",
  "PhD in Environmental Science (PhD EnvSci)",
  "PhD in Climate Science (PhD Climate Science)",
];

const extraCertificates = [
  "Professional Diploma in Accountancy (PD Accountancy)",
  "Postgraduate Diploma in Management (PGDM)",
  "Postgraduate Diploma in Business Administration (PGDBA)",
  "PG Certificate in Data Science",
  "PG Certificate in Machine Learning",
  "PG Certificate in Cloud Architecture",
  "Advanced Certificate in Cybersecurity",
  "Advanced Certificate in Digital Forensics",
  "Certificate in Clinical Data Management",
  "Certificate in Medical Coding",
  "Certificate in Telemedicine",
  "Certificate in Additive Manufacturing (3D Printing)",
  "Certificate in Advanced Manufacturing",
  "Certificate in GIS and Remote Sensing",
  "Certificate in School Leadership",
  "Certificate in Nonprofit Management",
  "Certificate in Energy Management",
  "Certificate in Sustainable Development",
  "Certificate in UX Research",
  "Certificate in Mobile App Development",
  "Certificate in Ethical Hacking",
  "Certificate in DevOps Practices",
  "Certificate in Blockchain Development",
  "Certificate in Quantitative Finance",
  "Certificate in Investment Banking Fundamentals",
  "Certificate in Luxury Brand Management",
  "Certificate in Digital Content Strategy",
  "Certificate in Sports Coaching",
  "Certificate in Aviation Management",
  "Certificate in Clinical Psychology Practice",
];

const pushUnique = (arr, items) => {
  items.forEach((it) => {
    if (!arr.includes(it)) arr.push(it);
  });
};

pushUnique(degreesByLevel.bachelor, extraBachelorSpecializations);
pushUnique(degreesByLevel.master, extraMasterSpecializations);
pushUnique(degreesByLevel.doctoral, extraDoctoralSpecializations);
pushUnique(degreesByLevel.certificate, extraCertificates);

const regionalAndProfessional = [
  "Licentiate in Theology (LTh)",
  "Licentiateship (Licentiate)",
  "Higher National Diploma (HND)",
  "Higher National Certificate (HNC)",
  "National Diploma (ND)",
  "National Certificate (NC)",
  "Graduate Diploma (GradDip)",
  "Bachelor of Laws (Honours) (LLB Hons)",
  "Master of Research (MRes)",
  "Master of Philosophy (MPhil)",
  "Diploma in French Language (Diplôme de Langue Française)",
  "Diploma in German Language (Zertifikat Deutsch)",
  "Diploma in Spanish Language",
  "Chartered Accountant (CA) - professional qualification",
  "Certified Public Accountant (CPA) - professional qualification",
  "Chartered Financial Analyst (CFA) - certification",
  "Company Secretary (CS) - professional qualification",
  "Cost and Management Accountant (CMA) - professional qualification",
  "Diploma in Film Production",
  "Postgraduate Certificate in Education (PGCE)",
  "Advanced Diploma in Management",
  "Higher Diploma in Business Studies",
  "Graduate Certificate in Education",
  "Postgraduate Diploma in Education (PGDE)",
  "Diploma in Graphic Design",
  "Diploma in Interior Architecture",
  "Diploma in Fashion Technology",
  "Diploma in Applied Linguistics",
];

pushUnique(degreesByLevel.certificate, regionalAndProfessional);
pushUnique(degreesByLevel.master, ["Master of Research (MRes)"]);
pushUnique(degreesByLevel.doctoral, ["Doctor of Philosophy (DPhil)"]);

const degreesList = [
  ...degreesByLevel.associate,
  ...degreesByLevel.bachelor,
  ...degreesByLevel.master,
  ...degreesByLevel.doctoral,
  ...degreesByLevel.certificate,
].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));

const createValueFromLabel = (label) => {
  return label
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, "")
    .replace(/\s+/g, "_")
    .trim();
};

const extractAbbreviation = (degree) => {
  const match = degree.match(/\(([^)]+)\)$/);
  return match ? match[1] : undefined;
};

const getDegreeLevel = (degree) => {
  for (const [level, degrees] of Object.entries(degreesByLevel)) {
    if (degrees.includes(degree)) {
      return level;
    }
  }
  return "certificate";
};

const degreesOptions = degreesList.map((degree) => ({
  value: createValueFromLabel(degree),
  label: degree,
  level: getDegreeLevel(degree),
  abbreviation: extractAbbreviation(degree),
}));

/**
 * Get degrees by specific level
 * @param {string} level - The degree level (associate, bachelor, master, doctoral, certificate)
 * @returns {string[]} Array of degrees for the specified level
 */
const getDegreesByLevel = (level) => {
  return degreesByLevel[level] || [];
};

/**
 * Search degrees by query string
 * @param {string} query - Search query
 * @returns {string[]} Array of matching degrees
 */
const searchDegrees = (query) => {
  if (!query || typeof query !== "string") return degreesList;

  const lowerQuery = query.toLowerCase().trim();
  return degreesList.filter((degree) =>
    degree.toLowerCase().includes(lowerQuery)
  );
};

/**
 * Get all degrees as option objects
 * @returns {object[]} Array of degree options with value, label, level, and abbreviation
 */
const getDegreesAsOptions = () => {
  return [...degreesOptions];
};

/**
 * Filter degrees by multiple levels
 * @param {string[]} levels - Array of levels to include
 * @returns {object[]} Array of filtered degree options
 */
const filterDegreesByLevel = (levels) => {
  if (!Array.isArray(levels) || levels.length === 0) return degreesOptions;

  return degreesOptions.filter((option) => levels.includes(option.level));
};

/**
 * Get degree statistics
 * @returns {object} Statistics about the degrees collection
 */
const getDegreeStats = () => {
  return {
    total: degreesList.length,
    byLevel: Object.fromEntries(
      Object.entries(degreesByLevel).map(([level, degrees]) => [
        level,
        degrees.length,
      ])
    ),
    withAbbreviations: degreesOptions.filter((opt) => opt.abbreviation).length,
  };
};

/**
 * Validate if a degree exists in the collection
 * @param {string} degree - Degree name to validate
 * @returns {boolean} True if degree exists
 */
const isValidDegree = (degree) => {
  return degreesList.includes(degree);
};

/**
 * Get random degree(s) - useful for testing/demos
 * @param {number} count - Number of random degrees to return (default: 1)
 * @returns {string|string[]} Random degree(s)
 */
const getRandomDegrees = (count = 1) => {
  const shuffled = [...degreesList].sort(() => Math.random() - 0.5);
  return count === 1 ? shuffled[0] : shuffled.slice(0, count);
};

const collegeDegreesData = {
  degreesList,
  degreesOptions,
  degreesByLevel,
  getDegreesByLevel,
  searchDegrees,
  getDegreesAsOptions,
  filterDegreesByLevel,
  getDegreeStats,
  isValidDegree,
  getRandomDegrees,
};

module.exports = collegeDegreesData;

module.exports.degreesByLevel = degreesByLevel;
module.exports.degreesList = degreesList;
module.exports.degreesOptions = degreesOptions;
module.exports.getDegreesByLevel = getDegreesByLevel;
module.exports.searchDegrees = searchDegrees;
module.exports.getDegreesAsOptions = getDegreesAsOptions;
module.exports.filterDegreesByLevel = filterDegreesByLevel;
module.exports.getDegreeStats = getDegreeStats;
module.exports.isValidDegree = isValidDegree;
module.exports.getRandomDegrees = getRandomDegrees;
